import { Link } from 'react-router-dom';
import { ChevronDownIcon, CircleIcon } from 'lucide-react';
import { launchList } from '../../data/adminLaunch';
import { plural } from '../../core/format/text';

/** Vóór livegang: ingeklapt onderaan, zodat het het dagelijkse werk niet wegdrukt. Lege lijst = weg. */
export function LaunchChecklist() {
  if (launchList.length === 0) return null;
  return <details className="group rounded-lg border border-line bg-white" data-id="element-1615" data-mp="oszc7ezj5h0h">
      <summary className="flex cursor-pointer list-none items-center justify-between gap-4 px-4 py-4 sm:px-5 [&::-webkit-details-marker]:hidden" data-id="element-1616" data-mp="au9atn5ogv6b">
        <span className="text-[15px] font-medium text-ink" data-id="element-1617" data-mp="xwjgvxluteq">
          Vóór livegang
          <span className="ml-2 font-normal text-muted" data-id="element-1618" data-mp="5whn75c2fv7x">{plural(launchList.length, 'punt', 'punten')} open</span>
        </span>
        <ChevronDownIcon className="h-4 w-4 shrink-0 text-muted transition-transform duration-150 ease-soft group-open:rotate-180" strokeWidth={1.5} aria-hidden="true" data-id="element-1619" data-mp="1vb5yf38x774d" />
      </summary>
      <ul className="grid gap-x-8 gap-y-2.5 border-t border-line px-4 py-4 sm:grid-cols-2 sm:px-5" data-id="element-1620" data-mp="3mr4ll5fkkx0l">
        {launchList.map(l => <li key={l.text} className="flex items-start gap-2.5 text-[14px]" data-id="element-1621" data-mp="3hrs0ap4cjy04">
            <CircleIcon className="mt-1 h-3.5 w-3.5 shrink-0 text-muted" strokeWidth={1.75} aria-hidden="true" data-id="element-1622" data-mp="ccuphydwejg" />
            {l.to ? <Link to={l.to} className="text-ink underline-offset-4 hover:text-clay hover:underline" data-id="element-1623" data-mp="3rj64ha78tlzl">
                {l.text}
              </Link> : <span className="text-muted" data-id="element-1624" data-mp="2yuqtqzv59pu2">{l.text}</span>}
          </li>)}
      </ul>
    </details>;
}